export default __webpack_public_path__ + "static/media/carta9.6de2a51a.png";